import './NewsTicker.scss';
import * as React from 'react';
import classNames from 'classnames';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { formatDate } from '../../../utils/dateUtils';
import Tag from '../../Tag';

type NewsTickerItemProps = {
  index: number;
  item: INewsListItem;
  className?: string;
  onClick: () => void;
};

const tags = {
  new: { color: 'warning', text: 'Nyt' },
  cancelled: { color: 'danger', text: 'Aflyst' }
};

const NewsTickerItem = ({
  item,
  index,
  className,
  onClick,
}: NewsTickerItemProps) => {
  let tagElement;

  if (item.newsLabel) {
    const newsLabelOption = tags[item.newsLabel];
    if (newsLabelOption) {
      const { color, text } = newsLabelOption;

      tagElement = <Tag color={color} size="mini">{text}</Tag>;
    }
  }

  return (
    <div
      key={item.id}
      className={classNames(
        'NewsTickerItem animate :fade-in',
        `:delay-${(index + 1) * 100}`,
        className,
      )}
      onClick={() => onClick()}
    >
      <div className="flex items-center mb-1">
        <div className="f6 uppercase mr-2">
          {item.publishedAt ? formatDate(item.publishedAt, 'do MMMM yyyy') : null}
        </div>
        {tagElement}
      </div>
      <div className="f5 font-semibold underline hover:no-underline cursor-pointer">
        {item.title}
      </div>
    </div>
  );
};

type NewsTickerProps = {
  news: INewsListItem[];
  isFirstPage: boolean;
  isLastPage: boolean;
  className?: string;
  onItemClick: (id: string | number) => void;
  onArchiveClick: () => void;
  onPreviousPageClick: () => void;
  onNextPageClick: () => void;
};

const NewsTicker = ({
  news,
  isFirstPage,
  isLastPage,
  className,
  onItemClick,
  onArchiveClick,
  onPreviousPageClick,
  onNextPageClick,
}: NewsTickerProps) => {
  return (
    <div className={classNames('NewsTicker', className)}>
      <div className="flex items-center font-bold mb-4">
        <h3 className="f4 uppercase my-0">Nyheder</h3>
        <span className="f5 ml-2 uppercase">//</span>
        <button
          className="cursor-pointer py-0 h-6 f5 underline hover:no-underline font-semibold ml-2"
          onClick={onArchiveClick}
        >
          Gå til nyhedsarkiv
        </button>
      </div>
      <div className="flex items-center relative">
        <div className="NewsTickerItems flex-1">
          {news.map((item, index) => (
            <NewsTickerItem
              key={item.id}
              index={index}
              item={item}
              onClick={() => onItemClick(item.id)}
            />
          ))}
        </div>
        <nav>
          <button
            disabled={isLastPage}
            onClick={() => onNextPageClick()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                d="M16.337 8.667l3.335 3.335-3.335 3.335m3.335-3.335H4.329"
              />
            </svg>
          </button>
          <button
            disabled={isFirstPage}
            onClick={() => onPreviousPageClick()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                d="M7.664 15.333l-3.336-3.335 3.336-3.335m-3.336 3.335h15.343"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default NewsTicker;



// WEBPACK FOOTER //
// ./src/components/News/NewsTicker/index.tsx